import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeWelcome(packet, writer = new BinaryWriter(64)) {
    writer
        .u8(ServerOp.Welcome)
        .u32(packet.entityId)
        .u32(packet.tick)
        .u16(packet.tickRate)
        .u16(packet.stepMs)
        .u16(packet.regionId)
        .u16(packet.width)
        .u16(packet.height)
        .u8(packet.floors)
        .u8(packet.groundFloor)
        .str8(packet.regionName);
    return writer;
}
export function decodeWelcome(reader) {
    return {
        entityId: reader.u32(),
        tick: reader.u32(),
        tickRate: reader.u16(),
        stepMs: reader.u16(),
        regionId: reader.u16(),
        width: reader.u16(),
        height: reader.u16(),
        floors: reader.u8(),
        groundFloor: reader.u8(),
        regionName: reader.str8(),
    };
}
//# sourceMappingURL=welcome.js.map